/**
 * Created by roman.kupin on 10/3/2017.
 */

import { combineReducers } from '@ngrx/store';
import bigPicture from "../big-picture/reducers/index";
import partners from "../partners/reducers/index";

const cooperativeReducer = combineReducers({
    bigPicture,
    partners
});
export default cooperativeReducer;

